// @flow
import React from 'react';
import Breadcrumbs from '@homeaway/react-breadcrumbs';

import type {DestinationShape} from '../../queries/searchQuery';

import './Breadcrumb.less';

type Props = {
    destination: ?DestinationShape
};

export default (props: Props) => {
    const {breadcrumbs = []} = props.destination || {};
    return (
        !!breadcrumbs.length && (
            <div className="breadcrumb">
                <div className="breadcrumb__container">
                    <Breadcrumbs crumbs={breadcrumbs} isLastCrumbLinked />
                </div>
            </div>
        )
    );
};
